var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.96582 9.99944L1.44569 9.49636L10.8315 0.0844727L11.8277 1.08343L3.62198 9.31194H27.193V10.6869H3.62198L11.8277 18.9155L10.8315 19.9144L1.44569 10.5025L0.96582 9.99944Z",
    fill: "#0F0F11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBack);
export default __webpack_public_path__ + "static/media/ico-back.14e8758d6687d8e7624272bda62bf6bc.svg";
export { ForwardRef as ReactComponent };